import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';
import { SharedService } from './services/shared.service';

@Injectable({
  providedIn: 'root'
})
export class TranslationService {
  private translations: { [key: string]: any } = {};
  private currentLangSubject = new BehaviorSubject<string>('en');
  currentLang$ = this.currentLangSubject.asObservable();

  constructor(
    private http: HttpClient, 
    @Inject(PLATFORM_ID) private platformId: object,
    private _sharedService: SharedService
  ) {
    const savedLanguage = this._sharedService.getLocalStorage('language') || 'en';  
    this.loadTranslations(savedLanguage);
  }

  loadTranslations(lang: string): void {
    const supportedLanguages = ['en', 'ja', 'ko'];
    lang = supportedLanguages.includes(lang) ? lang : 'en';
    this.http.get(`assets/i18n/${lang}.json`).subscribe({
      next: (translations) => {
        this.translations[lang] = translations;
        this.currentLangSubject.next(lang);
      }
    }
    );
  }

  getTranslations(): { [key: string]: string } {
    const savedLanguage = this._sharedService.getLocalStorage('language') || 'en';
    return this.translations[savedLanguage] || {};
  }

  setLanguage(lang: string): void {
    const supportedLanguages = ['en', 'ja', 'ko'];
    lang = supportedLanguages.includes(lang) ? lang : 'en';
    this._sharedService.setLocalStorage('language', lang);
    if (!this.translations[lang]) {
      this.loadTranslations(lang);
    } else {
      this.currentLangSubject.next(lang);
    }
  }
}
